var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.classes,
      attrs: {
        "aria-label": _vm.$t("wizard.noRecommendationRestartButtonTitle"),
      },
      on: { click: _vm.onClick },
    },
    [
      _c("icon", {
        staticClass: "trbo-a-question-restart-button__icon",
        attrs: { name: "reload" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }